/**
 * Auth-only Axios Client
 *
 * A minimal, dedicated axios instance used exclusively for authentication
 * endpoints (token obtain, refresh, verify). It intentionally has NO request
 * or response interceptors so that token-refresh calls never re-enter the
 * auth-refresh logic in apiService.ts and create an infinite loop.
 *
 * ⚠️  Do NOT add interceptors to this client.
 * ⚠️  Do NOT use this client for general API calls — use businessApi / workformsApi.
 */

import { config } from '../config/runtime';
import { createHttpClient, isAxiosError } from './axiosUtils';

export const authClient = createHttpClient({
  baseURL: config.API_BASE_URL,
  timeout: 10_000,
  headers: {
    'Content-Type': 'application/json',
  },
  // JWT token endpoints authenticate via POST body (username/password or
  // refresh token) — no session cookie is needed.  Sending cookies causes
  // Django's SessionMiddleware to create/renew sessions, which then conflict
  // with JWT auth in the tenant middleware on subsequent requests.
  withCredentials: false,
});

/** Re-exported for callers that need to discriminate Axios errors. */
export { isAxiosError };
